import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"close\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.157 15.6973L17.208 15.638L11.1238 9.67319L9.62835 11.1687L14.157 15.6973ZM8.42627 9.96658L9.90983 8.48302L8.59904 7.19797L7.12835 8.66866L8.42627 9.96658ZM2.84329 1.55518L7.38505 6.0078L5.92627 7.46658L0.0148621 1.55518H2.84329Z\" />\n<path d=\"M3.05101 15.6975L1.23036e-07 15.6382L14.3647 1.55539L17.1931 1.55539L3.05101 15.6975Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol